import { useSidebar } from "@/contexts/SidebarContext";
import HeaderInfo from "../components/Header/HeaderInfo";
import Logo from "../components/Header/Logo";
import { FiSidebar } from "react-icons/fi";
import { isWeb } from "@/utils/helpers";

function Header() {
  const { isShowingIconsOnly, setIsShowingIconsOnly } = useSidebar();

  return (
    <header
      className={`col-span-12 row-span-1 grid ${isShowingIconsOnly ? "grid-cols-[80px_repeat(11,1fr)]" : "grid-cols-[260px_repeat(11,1fr)]"} items-center justify-start transition-[grid] duration-200 ${!isWeb ? "bg-sidebar sm:bg-transparent": ""}`}
    >
      <Logo />

      {/* HeaderInfo */}
      <div className="col-span-11 hidden h-full items-center border-b border-gray-200 md:flex gap-x-1 md:ps-1 ">
        <button type="button" className={`mx-1 hover:bg-black/10 p-2 rounded-md mt-1 ${isShowingIconsOnly ? "bg-black/10" : ""}`} onClick={() => setIsShowingIconsOnly(!isShowingIconsOnly)}>
          <FiSidebar size={22} />
        </button>
        <HeaderInfo />
      </div>
    </header>
  );
}

export default Header;
